import { ReactNode } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@client/toolkit';

interface BuildingFilterPanelProps {
  title: string;
  searchPlaceholder: string;
  noTagsLabel: string;
  buildingFilter: string;
  onBuildingFilterChange: (value: string) => void;
  allTags: string[];
  activeTags: string[];
  onToggleTag: (tag: string) => void;
  /** Optional control rendered on the right of the header (e.g. a year picker). */
  action?: ReactNode;
}

/** Filter side-panel for the portfolio reports: a building name search plus toggleable tag pills. */
export function BuildingFilterPanel({
  title,
  searchPlaceholder,
  noTagsLabel,
  buildingFilter,
  onBuildingFilterChange,
  allTags,
  activeTags,
  onToggleTag,
  action,
}: BuildingFilterPanelProps) {
  return (
    <Card>
      <CardHeader className="items-center">
        <CardTitle variant="highlighted">{title}</CardTitle>
        {action}
      </CardHeader>
      <CardContent variant="fill" className="px-4 pb-4 flex flex-col gap-3">
        <input
          value={buildingFilter}
          onChange={(e) => onBuildingFilterChange(e.target.value)}
          placeholder={searchPlaceholder}
          className="bg-surface-elevated/40 border border-border rounded-md px-3 py-2 text-sm text-white w-72"
        />
        {allTags.length > 0 ? (
          <div className="flex flex-wrap gap-2">
            {allTags.map((tag) => {
              const active = activeTags.includes(tag);
              return (
                <button
                  key={tag}
                  type="button"
                  onClick={() => onToggleTag(tag)}
                  className={`px-2.5 py-1 rounded-full text-xs font-medium border transition-colors ${
                    active
                      ? 'bg-brand-primary/20 text-brand-primary border-brand-primary/40'
                      : 'bg-surface-elevated/30 text-white/70 border-border hover:text-white'
                  }`}
                >
                  {tag}
                </button>
              );
            })}
          </div>
        ) : (
          <span className="text-white/40 text-xs">{noTagsLabel}</span>
        )}
      </CardContent>
    </Card>
  );
}
